import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { DividerCore } from '../Divider.Core/Divider.Core.es.js';

const DividerLabelled = ({ iconName, text, className })=>{
    return jsxs("div", {
        "aria-label": text,
        "aria-orientation": "horizontal",
        className: classNames('cb-divider-labelled', className),
        "data-testid": "divider-labelled",
        role: "separator",
        children: [
            jsx("div", {
                "aria-hidden": "true",
                className: "line",
                children: jsx(DividerCore, {})
            }),
            jsxs("div", {
                className: "text-content",
                children: [
                    iconName && jsx(Icon, {
                        className: "icon",
                        name: iconName,
                        size: 16
                    }),
                    text && jsx("span", {
                        className: "label",
                        children: text
                    })
                ]
            }),
            jsx("div", {
                "aria-hidden": "true",
                className: "line",
                children: jsx(DividerCore, {})
            })
        ]
    });
};
DividerLabelled.displayName = 'Divider.Labelled';

export { DividerLabelled };
//# sourceMappingURL=Divider.Labelled.es.js.map
